import React, { useState } from "react";
import DataTable from "../../../Components/UI/table/DataTable";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { getWithdrawals, updateWithdrawal } from "../../../MyApi/withdrawals";
import StatusBadge from "../../../Components/UI/statusBadge";
import Can from "../../../utils/can";
import FilterBar from "../../../Components/UI/filterbar";
import { Spinner } from "reactstrap";
import { formatPrice } from "../../../utils/formatPrice";
import { toast } from "react-toastify";
import PaymentActions from "./paymentActions";
  
const PaymentRequestsTab = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    search: "",
    store_id: "",
    date: ""
  });
  const queryClient =useQueryClient()
    const { data: withdrawalsData, isLoading: loadingWithdrawals ,isFetching ,refetch} = useQuery(
    ["getWithdrawals", filters, currentPage],
    () => getWithdrawals(currentPage, filters)
  );    

const mutation = useMutation({
  mutationFn: ({ id, status }) => updateWithdrawal({ status ,_method:"PUT" },id),
  onSuccess: (data) => {
 toast.success(`${data.message}`)
     queryClient.invalidateQueries(["getWithdrawals"]);
  },
});



 const paymentRequestsColumns = [
  { label: "معرف الطلب", render:(row)=> <div className="text-green"> {row.id}</div>  },
  { label: "المتجر", accessor: "withdrawable.name" },
     
  {
    label: "المبلغ المطلوب",
    render: (row) => (
      <div>
        {formatPrice(row.currency_factor, row.amount)} {row.currency_code}
      </div>
    ),
  },
  { label: "تاريخ الطلب", accessor: "created_at" },

  {
    label: "الحالة",
    render: (row) => (
      <StatusBadge
        status={row.status === "approved" ? "active" : "inActive"}
        statusLabel={row.status}
      />
    ),
  },

   
  {
    label: "الإجراءات",
    render: (row) => 
    
  <PaymentActions
    row={row}
    onUpdate={(id, status) =>
      mutation.mutateAsync({ id, status })
    }
  />
  },    
];

  const withdrawals = withdrawalsData?.data?.Withdrawals || [];
  const total = withdrawalsData?.data?.pagination?.total || 0;
  const last_page = withdrawalsData?.data?.pagination?.last_page || 0;

  const handleFilterChange = (newFilters) => {
    setCurrentPage(1); // Reset to first page when filters change
  };

  const handleResetFilters = () => {
    setFilters({
      search: "",
      store_id: "",
      date: ""
    });
    setCurrentPage(1);
  };

  const filtersConfig = {
    search: true,
    store: true,
    date: true
  };

  return (
    <Can permission={"view_withdrawal"}>
      <FilterBar
        filters={filters}
        setFilters={setFilters}
        filtersConfig={filtersConfig}
        placeholder="البحث حسب اسم المتجر..."
        onFilterChange={handleFilterChange}
        onResetFilters={handleResetFilters}
      />
      <DataTable
        columns={paymentRequestsColumns}
        data={withdrawals || []}
        title="طلبات الدفع "
        totalItems={total}
        itemsPerPage={last_page}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        isLoading={loadingWithdrawals}
        isFetching={isFetching}
      />
    </Can>
  );
};

export default PaymentRequestsTab;
